import LogUser from "@/service/LogUser.js";
import LogUTM from "@/service/LogUTM.js";

const state = {
  logInfo: {},
  utmInfo: {}
};

const mutations = {
  insertLog(state, obj) {
    state.logInfo = obj;
    this._vm.$cathayAxios.post(LogUser.insertLog, obj);
  },
  insertUTM(state, obj) {
    state.utmInfo = obj;
    this._vm.$cathayAxios.post(LogUTM.insert, obj);
  }
};

const actions = {
  insertLog(context, obj) {
    context.commit("insertLog", obj);
  },
  insertUTM(context, obj) {
    context.commit("insertUTM", obj);
  }
};

export default {
  state,
  mutations,
  actions
};
